export const langJa = {
  header: {
    menu: {
      user: 'ユーザー：{{value}}さん',
      login: 'ログイン',
      logout: 'ログアウト',
      member: '会員情報確認',
    },
    landing: {
      company: '運用会社',
      info: 'お問い合わせ',
    },
  },
  common: {
    close: '閉じる',
    cancel: '取り消す',
    execute: '実行する',
    edit: '編集',
    delete: '削除',
    registeredLocations: '登録地点',
    analyzedLocations: '分析済み地点',
    analyzableLocations: '分析可能地点',
    locationName: '地点名',
    tagName: 'タグ',
    address: '住所',
    facility: '施設名',
    status: '分析状況',
    analysis: '分析済',
    analysisInProgress: '分析中',
    analysisFailed: '分析失敗(再分析)',
    analyzing: '分析する',
    unanalyzed: '未分析',

    alert: {
      privacy: 'プライバシーポリシーに同意しました',
    },

    button: {
      register: '登録する',
      detail: '確認画面',
      send: '送信',
      edit: '入力内容を編集',
      update: '変更を反映する',
      upload: 'アップロード',
      export: 'CSVファイルで結果をエクスポート',
      showgraph: 'グラフを表示',
      cancel: 'キャンセル',
      add: '追加',
      back: '戻る',
    },

    menu: {
      climateRiskAssessment: '気候リスク評価',
      dashboard: 'ダッシュボード',
      climate_vision: 'Climate Vision',
      freeDashboard: '簡易ハザードマップ',
      newLocation: '地点登録',
      locations: '地点一覧・分析',
      addLocation: '新規地点登録',
      results: '分析結果',
      help: 'ヘルプ',
      helpUse: 'アプリの使い方',
      helpDesc: '分析手法と結果',
      faq: 'FAQ',
      used: '利用規約',
      privacy: 'プライバシーポリシー',
      info: 'お問い合わせ',
      // ここからリアルタイム洪水側
      realTimePrediction: 'リアルタイム洪水予測',
      predictionMap: '洪水予報マップ',
      alertSetting: 'アラート設定',
      addAlert: '新規登録',
      addNewAlert: '新しいアラートの登録',
      editAlert: 'アラートを編集',
      alertList: '一覧確認 / 編集',
      alertDetail: 'アラート条件設定',
      customer: '顧客情報',
      tutorial: 'チュートリアル',
      tooltip: {
        climateVision: "気候リスク分析を行う別のWebアプリケーションになります。無償でご利用頂けますがご利用には別途アカウント作成が必要になります。"
      }
    },

    label: {
      locationName: '拠点名',
      tagName: 'タグ',
      address: '住所',
      region: '国・地域',
      latitude: '緯度',
      longitude: '経度',
      assets: '資産高',
      sales: '売上高',
      bldgType: '資産種別',
      currency: '通貨',
      description: '説明',
      information: 'ご用件',
      contents: '内容',
      yearReturnPeriod: '浸水深（100年再現期間）',
      currentClimate: '現在気候',
      scenarioA: '1.5℃シナリオ',
      scenarioB: '2℃シナリオ',
      scenarioC: '4℃シナリオ',
      floodDepth: '浸水深(m)',
      totalImpactWithoutCurrency: '影響総額',
      totalImpact: '影響総額(千{{value}})',
      damageToAssets: '資産への被害(千{{value}})',
      damageToSales: '売上への被害(千{{value}})',
      damageRate: '被害率(％)',
      operatingDays: '営業影響日数(日)',
      depthOfFlooding: '浸水深',
      financialImpact: '財務影響',
      recurrencePeriod: '再現期間',
      year: '年',
      scenario: 'シナリオ',
      location: '地点',
      locationInformation: '地点情報',
      assetHeight: '資産高',
      netSales: '売上高',
      ThousandsOfYen: '千{{value}}',
      customer: '会社名',
      department: '部署名',
      personName: 'ご担当者名',
      email: 'メールアドレス',
      inquiryType: 'お問い合わせ種別',
      inquiryDetails: 'お問い合わせ内容',
      accountId: 'アカウントID',
      password: 'パスワード',
      username: 'ご担当者名',
      createdAt: 'アカウント作成日',
      effectivedAt: '有効期限',
      plan: 'プラン',
      free: '無料プラン',
      transmittance: '浸水深の透過率',
      backgroundmap: '背景地図',
      default: 'デフォルト',
      dark: 'ダーク',
      satellite: '航空写真',
      datasouce: 'データソース',
      gaiavision: 'Gaia Vision',
      mlit: '国土交通省',
    },
  },
  schema: {
    require: '必須です',
    number: '整数で入力してください',
    email: '正しいメールアドレスを入力してください',
    value: '正しく入力されていません',
  },
  components: {
    LocationRegisterMap: {
      desc: '赤枠内は分析範囲となります。',
    },
    floodDepthMeter: {
      overFiveMeters: '2階以上が浸水する',
      twoToFiveMeters: '2階軒下まで浸水する',
      oneToTwoMeters: '1階部分が浸水',
      halfToOneMeter: '50cm超で車両走行困難',
      tenthToHalfMeter: '30cm超で歩行困難',
      openLegend: '浸水深の凡例を開く',
      closeLegend: '浸水深の凡例を閉じる',
      referenceImage: '浸水深の目安',
    },
  },
  pages: {
    user: {
      title: 'ユーザー情報',
    },

    rootMain: {
      title: '気候変動のリスクを管理する<br />ただ１つのアプリケーション',
      maintenance: 'メンテナンス情報',
      subTitle: 'ご利用方法',
      list: {
        itemA: {
          title: '1. 地点を登録',
          desc: '世界中、どこでも簡単に地点登録',
        },
        itemB: {
          title: '2. 分析を実行',
          desc: '最先端のデータでリスク分析',
        },
        itemC: {
          title: '3. 結果表示・ダウンロード',
          desc: '気候リスクを地図上にわかりやすく表示',
        },
      },
    },

    dashboard: {
      title: '地点サマリー',
      subTitle: '分析結果サマリー',
      infoTitle: 'お知らせ',
      tooltip: {
        a: 'Gaia Vision: 東京大学で開発されたグローバル河川氾濫モデルCaMa-Floodを用いて、Gaia Visionが独自にシミュレーションを行った結果。世界中をカバー。CaMa-Floodは、IPCC AR6でも引用されるなど、世界中の研究機関で利用されているモデルである。また、Gaia Visionは独自にライセンスを受けた高解像度地形データを用いてシミュレーションを回しており、極値統計解析によりN年に1度の洪水リスクを算定している。洪水リスク評価のプロダクト例として、国土交通省の手引に掲載。（「TCFD 提言における物理的リスク評価の手引き」）。無償版では、100年に1度の洪水リスクを表示。MLIT: 日本の国土交通省や都道府県により作成されたハザードマップ。日本国内のみ（一部の中小河川は含まない）。Gaia Visionの手法とは異なり、過去の統計に基づき想定最大規模の降雨を降らせた場合の洪水シミュレーションを流域ごとに実施。1000年に1度の洪水リスク。',
      },
    },

    freeDashboard: {
      title: '簡易ハザードマップ',
      map: {
        desc: 'より詳細には、地点登録の上、分析を実行してください',
      },
    },

    results: {
      title: '分析結果：洪水リスク',
      subTitleA: 'リスク評価結果',
      subTitleB: 'リスク全体マップ',
      subTitleC: '周辺ハザードマップ',

      tabs: {
        whole: '全体',
        individual: '個別地点',
      },

      button: {
        update: '分析結果を更新する',
      },

      tooltip: {
        a: '1000年の再現期間は1000年に一度の洪水を示します。長いほど、稀な洪水であるということを示します。詳細は「分析手法と結果」ページをご覧ください。',
        b: '4℃シナリオとは、気候変動に関連する将来の予測シナリオの一つで、産業革命前と比較して地球の平均気温が4℃上昇する状況を指します（1.5℃/2℃も同様）。4℃シナリオは、温室効果ガスの削減努力が不十分な場合に発生するとされるものであり、1.5℃はパリ協定の目標となっているものです。詳細は「分析手法と結果」ページをご覧ください。無償版では、4℃シナリオのみ表示可能。',
      },
    },

    rootContact: {
      title: 'お問い合わせ',
      desc: '',

      const: {
        title: {
          a: { value: 'リスク分析', label: 'リスク分析' },
          b: { value: '情報開示', label: '情報開示' },
          c: { value: '防災', label: '防災' },
          d: {
            value: '気候変動の情報収集',
            label: '気候変動の情報収集',
          },
          e: { value: 'その他', label: 'その他' },
        },
      },

      alert: {
        submit: {
          ok: 'お問い合わせを送信しました',
          ng: 'お問い合わせを送信できませんでした',
        },
      },
    },

    appContact: {
      title: 'お問い合わせ',
      desc: '',

      const: {
        title: {
          a: {
            value: 'アプリケーションの使い方について',
            label: 'アプリケーションの使い方について',
          },
          b: { value: '分析結果について', label: '分析結果について' },
          c: {
            value: '研究・技術について',
            label: '研究・技術について',
          },
          d: { value: 'その他', label: 'その他' },
        },
      },

      alert: {
        submit: {
          ok: 'お問い合わせを送信しました',
          ng: 'お問い合わせを送信できませんでした',
        },
        content: 'お問い合せの内容はお客様のメールアドレスにも送信されます',
      },
    },
    newLocations: {
      title: '新規地点登録',
      tab: {
        individual: '個別登録',
        bulk: 'CSV一括登録',
      },
      alert: {
        showMap: '緯度または経度を入力してください。',
        geocode: '正しい住所または施設名を入力してください。',
      },
      bulk: {
        desc: 'CSVファイルから、まとめて拠点情報を登録できます。',
        link: '※ サンプルCSVファイル',
        contents: {
          csv: {
            title: 'CSV入力規則',
            desc: {
              a: '以下の3項目については、下記に指定のリストの中から記載してください。（画像赤枠）',
              b: 'region（国・地域　※財務影響評価にて参照）',
              c: 'bldg_type（資産種別）',
              d: 'currency（通貨）',
            },
            label: {
              value: '値',
              desc: '意味',
            },
            value: {
              japan: '日本',
              asia: '日本を除くアジア地域',
              africa: 'アフリカ',
              europe: 'ヨーロッパ',
              northAmerica: '北アメリカ',
              southAmerica: '南アメリカ',
              oceania: 'オセアニア',
              other: 'その他',
            },
          },
        },
      },
      form: {
        tag: {
          desc: '複数のタグを入力するときは、半角スペースで区切ってください。',
        },
        address: {
          placeholder: '東京駅',
          desc: '施設名などでも検索可能です。',
          button: '住所から緯度経度を入力',
        },
        latitude: {
          desc: '小数点6桁まで入力してください。北緯は＋、南緯はーです。',
        },
        longitude: {
          desc: '小数点6桁まで入力してください。東経は＋、西経はーです。',
          button: '地図を表示',
        },
      },
    },

    // 本登録用フォーム
    rootApplication: {
      title: '登録フォーム',
      fullName: '氏名',
      companyName: '会社名 / ご所属先名',
      department: '部署名',
      position: '役職',
      address: '本社所在地',
      phone: '電話番号',
      submit: {
        alert: {
          ok: '登録が完了しました。自動的にページが遷移します。',
          ng: '送信できませんでした',
        },
      },
      button: {
        confirm: '確認画面',
        register: '登録',
        edit: '入力内容を編集',
      },
      termsOfUse: {
        regardedAsAgreement: "<0>{{termsOfUse}}</0>と<1>{{privacy}}</1>への確認・同意のうえ、アカウント作成を行ってください。アカウント作成を行った場合、本規約に同意したものとみなされます。",
        termsOfUse: "利用規約",
        privacyPolicy: "プライバシーポリシー",
      }
    },

    editLocations: {
      title: '地点情報編集',
      alert: {
        showMap: '緯度または経度を入力してください。',
        geocode: '正しい住所または施設名を入力してください',
        analysis: '※ 分析済みの場合、住所と位置は変更できません',
      },
      form: {
        sales: {
          desc: '分析後に資産高、売上高を変更する場合は、変更を反映後、分析結果画面から、分析結果を更新してください。',
        },
      },
    },

    locations: {
      title: '登録地点一覧',
      allAnalyzable: 'すべて分析する',
      newLocations: '新規登録地点',
      deleteModal: {
        title: '「{{value}}」を削除しますか？',
        desc: '削除すると元に戻すことができません。',
      },
      analysisModal: {
        title: '「{{value}}」の分析を実行しますか？',
        desc: 'クレジットが１消費されます。<br />※ 緯度・経度が正しいことをご確認ください。',
      },
      analysisAllModal: {
        title: '未分析の地点をすべて分析しますか？',
        desc: 'クレジットが消費されます。<br />※ 緯度・経度が正しいことをご確認ください。',
      },
      analysisStartModal: {
        title: '分析を開始しました。',
      },
      analysisEndModal: {
        title: '分析が完了しました。',
        desc: '分析結果画面から、分析結果を更新してください。',
      },
      tooltip: {
        a: '地点情報を確認し、再分析を実行してください。',
      },
    },

    help: {
      title: 'ヘルプページ',
      subTitle: {
        a: '1.アカウント・プランについて',
        b: '2.分析・結果について',
        c: '3.その他',
      },
      contents: {
        a: {
          q: '分析可能な地点数を増やせますか？',
          a: 'はい、可能です。お問い合わせページからご連絡ください。プランの変更手順についてご連絡します。',
        },
        b: {
          q: 'アカウントのパスワードを変更したいです。',
          a: 'お問い合わせページから、パスワード変更の旨をお伝えください。',
        },
        c: {
          q: '同時に複数端末で1つのアカウントにログイン可能ですか？',
          a: '現状では、複数端末で1つのアカウントにログインすることは可能です。',
        },
        d: {
          q: '分析の結果はどれほど正しいですか？',
          a: '当社ハザードマップの結果と過去に発生した洪水被害の浸水域の比較を解説ページに掲載しています。実際の浸水域は洪水発生時の雨の量や振り方に大きく依存し、当社ハザードマップが必ず一致するとは限りません。<br/>また、当社ハザードマップは河川氾濫による洪水のみに対応しており、内水氾濫（都市型洪水）には対応できていません。詳しくは解説ページ（分析の限界）を御覧ください。<br/>利用規約に記載のとおり、本アプリによる分析結果は絶対のものではなく、リスクマネジメント等の参考としてご利用頂くようお願い申し上げます。',
        },
        e: {
          q: 'より広い地域のハザードマップを見たいです。',
          a: 'お問い合わせページから、ご覧になりたい地域や広さについてご連絡ください。',
        },
        f: {
          q: '河川や湖など、水上の地点の分析は可能でしょうか？',
          a: '現在の洪水ハザードマップは河川氾濫を対象にしているため、河川の水深についてもデータがございます。一方で、湖や池などのデータにはまだ未検証の部分があります。また海上は、洪水ハザードマップの対象外になります。',
        },
        g: {
          q: '他のリスクの分析はできないでしょうか。',
          a: '高潮や海面上昇、水ストレスなどのデータを研究開発しています。より具体的なご要望がある場合は、お問い合わせページからご相談ください。',
        },
      },
    },

    howTo: {
      title: 'アプリケーションの使い方',
      subTitle: {
        a: 'Climate Visionとは',
        b: '分析の手順',
        ba: '1.地点の登録',
        bb: '2.地点の編集',
        bc: '3.分析の実行',
        bd: '4.結果の閲覧',
      },
      contents: {
        aa: '世界中の洪水リスクを分析するWebアプリケーションです。河川洪水についての分析が可能です。',
        ab: '洪水リスクとは「○○年に1回発生する可能性がある洪水による浸水深および企業等に与える財務影響」を指します。「○○年」のことを「再現期間」と呼びます。',
        ac: '本システムでは、10年、100年、1000年に1回の洪水のリスク情報を提供いたします。',
        ad: '登録した地点に対して分析を実行し、その度にクレジットが消費されます。',
        ae: '1地点の分析＝1クレジット',
        af: '本システムへのアクセスは注文書に定められた契約期間に限り有効です。',

        ba: '1. 「新規地点登録」で地点を登録します',
        bb: '地点の名前や住所、説明を入力します。',
        bc: '各項目の詳細は以下の通りです。',
        bd: '拠点名：本システム内で使われる拠点の名称。建物の名前、社内での用途に応じた呼称等を設定します。',
        be: 'タグ（任意）：登録地点一覧画面に表示。主幹事業部など、詳細な分析を行う際に必要となる情報を設定いただけます。半角スペース区切りることで複数設定可能です。',
        bf: '住所（任意）：住所入力後、「住所から緯度経度を入力ボタン」を押下すると緯度経度が自動で入力されます。（Google APIを利用しています。多少ずれる場合があるので、地図上での位置もご確認ください）',
        bg: '緯度経度：実際の分析時は緯度経度をもとに行われます。',
        bh: '緯度・経度は小数点第6位までご記入下さい。',
        bi: '緯度・経度入力後、「地図上で確認」ボタンを押下することで、地図上にマーカーが表示されます。',
        bj: 'マーカーをドラッグすることで、緯度・経度を微調整いただけます。',
        bk: '売上高：当該拠点の売上高を入力します。財務影響評価における間接損害（営業停止に伴う損害）の評価に利用されます。工場の資産高などをご利用ください。',
        bl: '資産高：当該拠点の資産高を入力します。財務影響評価における直接損害（資産毀損による損害）評価に利用。各設備の棚卸し資産高の累計などをご利用ください。',
        bm: '説明（任意）：必要に応じて社内管理用に説明文を入力します。',
        bn: '地点情報は位置情報（「住所」「緯度経度」）を除き分析後も編集可能です。',
        bo: '（新規地点登録画面）',
        bp: 'CSVファイルを使って、複数地点を一度に登録することもできます。',
        bq: 'サンプルファイルを参照してCSVファイルを作成し、アップロードボタンからアップロードして下さい。',
        br: 'サンプルCSVファイル',
        bs: '緯度・経度は小数第6位までご入力下さい。',
        bt: '1つのCSVファイルで同時に登録できるのは100地点までです。',
        bu: '国・地域、資産種別、通貨は、あらかじめ決められた指定リストから入力する必要があります。「CSV一括登録」画面の説明をご確認ください',
        bv: '（CSV一括登録画面）',

        ca: '2. 「登録地点一覧」から登録した地点情報の確認・編集・削除ができます',
        cb: '未分析地点の情報の修正・削除が可能です。',
        cc: '分析実施済み地点は、住所・緯度経度を除き、修正が可能です。削除はできません。',
        cd: '（登録地点一覧画面）',

        da: '3. 「地点一覧画面」で「分析する」ボタンを押します',
        db: '「登録地点一覧」で分析をしていない地点には緑色の「分析する」ボタンが表示されます。「分析する」ボタンを押すと、分析が開始されます。',
        dc: '1地点あたり、20〜30秒ほどで分析が完了します。',
        dd: '分析を実行すると、「分析する」ボタンが「分析中」、「分析済み」の順に変化します。',
        de: '',

        ea: '4. 「分析結果」から分析結果が閲覧できます',
        eb: '分析を実行した全地点のリスクが世界地図に表示されます。',
        ec: '1000年に一度、100年に一度、10年に一度の規模の洪水の浸水深・財務影響を気候シナリオ別に確認いただけます。',
        ed: 'マーカーの色が濃いほどリスクが高いことを表します。',
        ee: '気候シナリオは、現在気候及び1.5℃、2℃、4℃上昇シナリオから選択することが可能です。',
        ef: '（分析結果表示画面: 浸水深）',
        eg: '左上で表示内容を財務影響に切り替えると、浸水深に対して推定される金額ベースでの想定被害・リスクが表示されます。',
        eh: 'こちらも浸水深と同様に、マーカーの色が濃いほど高いリスク（大きい想定被害額）を意味します。',
        ei: '（分析結果表示画面: 財務影響評価）',
        ej: '左上の「個別地点」タブを押すと、分析した各地点の周囲のハザードマップ・被害率・営業影響日数も確認可能です。',
        ek: 'ハザードマップとは、地図上に可視化された10年に1度、100年に1度、1000年に一度の浸水深の分布を指しています。',
        el: '閲覧可能な範囲は、分析地点の周辺四方2kmの範囲です。',
        em: 'より広い範囲のハザードマップをご希望の場合は、別途ご相談下さい。',
        en: '（分析結果表示画面: 個別地点詳細）',
        eo: 'すべてのデータは、各ページ下部の「CSVファイルで結果をエクスポート」からCSVファイルで取得可能です。個別地点のリスク評価結果は、各地点・各再現期間ごとに、それぞれのファイルとして出力が可能です。',
        ep: 'データ利用は自社および自社グループ企業内に限られます。',
        eq: 'ただし、TCFD等の情報開示を目的として外部に解析結果を示すことは可能です。',
        er: 'その他、第三者への提供・販売等をご希望される場合は、別途ご相談ください。',

        es: '資産種別：建物の性質で被害額が変わります。分析する建物や土地の性質に最も近いものを6種類から選んでください。',
      },
    },

    // ここからリアルタイム
    predictionMap: {
      showPins: '観測地点ピンを地図に表示',
      fld_prediction: '浸水',
      precipitation_pred: '河川水位',
      timestamp: '{{date}}時点',
      fetching: '最新のデータを取得中...',
      frameLoading: 'この時刻のデータを取得中...',
      frameError: 'この時刻のデータを取得できませんでした',
      frameDisplaying: '（表示中: {{date}}）',
      frameRetry: '再試行',
      frameFallback: '最新の解析がまだ取得できないため、{{date}}の解析を表示しています',
      // loadFailed: "現在システムメンテナンスに伴い地理データ取得機能が一時停止しております。ご不便をおかけしてしまい大変申し訳ございませんが、完了まで今しばらくお待ち頂けますと幸いです。",
      loadFailed: "非出水期につき11月頃より稼働を停止しております。5月下旬頃より稼働再開を予定しています。なお、「解析時刻を選択」より過去の時点から見た予測データの確認が可能です。",
      contact: "何かお困りの点がございましたら\n恐れ入りますが運営までご連絡頂けますと幸いです。",
      urlFetching: '予測マップのロード中',
      calculatedAt: '<0>{{date}}</0>の解析に基づく予測',
      chooseCalculatedTime:"解析時刻を選択",
      timeInterval:"<0>{{interval}}</0> 時間おきのデータを表示",
      tbd: "降水/河川予測データを掲載予定です（現在開発中）",
      settings: {
      dataSetting:"表示データ設定",
      dataTimeIncrement:"データ間隔",
      calculationTime:"起算時刻",
      timeIntervalOption: '{{interval}}時間ごと',
      yearOption: '{{year}}年',
      monthOption: '{{month}}月',
      dateOption: '{{date}}日',
      hourOption: '{{hour}}時',
      cancel:"キャンセル",
      saveSettings:"設定を保存",
      selectedTimeNotExist:"選択された起算時刻のデータが存在しません。",
      hourDesc: "{{increment}}時間先の予報",
      },
      paymentModal: {
        title: '有償版のお申し込みが必要です。',
        alert:"アラート登録機能",
        map:"将来の洪水予測マップ",
        featureIsLimited: 'は有償版にご登録頂くことでご利用頂けます。',
        paidPlan: "有償版",
        freePlan: "無償版",
        descriptionFree: "過去の水害のシミュレーション結果が見られる。",
        descriptionPaid: "最新の予測結果やアラート通知を受け取れる。",
        past: "過去",
        present:"現在",
        prediction: "将来の予測",
        notification:"通知機能",
        inquiry: 'お問い合わせページは',
        here:"こちら",
      },
      stationDetail: {
        locationInfo: '地点情報',
        riverForecast: '河川水位の予測',
        pastOnly: '過去のみ',
        pastAndForecast: '過去と予測',
        latestForecastWaterLevel: '最新の予測水位',
        peakForecastWaterLevel: '今後{{hours}}時間の予測ピーク水位',
        observedWaterLevel: '観測水位',
        thresholds: {
          floodWarning: '氾濫注意水位',
          evacuation: '避難判断水位',
          danger: '氾濫危険水位',
          planned: '計画高水位',
        },
        chart: {
          pastEstimate: '過去推測',
          forecast: '予測',
          latestTime: '最新時刻',
          riverWaterLevelAxis: '河川水位 [m]',
        },
      },
      registeredInfo: '登録情報',
    },

    // JMAの警報
    jmaAlerts: {
      title: '警報情報',
      detail: '詳細',
      currentlyPaused: '大雨・氾濫に関する気象庁発表情報のみ表示',
      publisher: '気象庁発表',
      noInformation: '情報なし',
      prefectureFallback: '都道府県',
      heavyRain: '大雨',
      flood: '氾濫',
      cleared: '解除',
      level: 'レベル{{level}}',
      legend: {
        level5: 'レベル5\n特別警報',
        level4: 'レベル4\n危険警報',
        level3: 'レベル3\n警報',
        level2: 'レベル2\n注意報',
      },
      legendWarning: {
        level5: '特別警報',
        level4: '危険警報',
        level3: '警報',
        level2: '注意報',
      },
    },
    // ここからアラート
    alerts: {
    addByAddress: '浸水深：地点登録',
    addByArea: '浸水深：エリア登録',
    addByRiverLevel: '河川水位：地点登録',
      areaName: '地点名',
      area:{
        topLeftLatLon: "北西の緯度経度", 
        bottomRightLatLon: "南東の緯度経度", 
      },
      addNewAlert:{
        enterAddress: "住所を入力",
        selectOnMap:"地図上で選択",
        editAreaName: "地点名を入力",
        otherSettings: "その他の設定",
        shareInClient: "組織内で共有", 
        desc: "地点やエリアを登録することで、指定した条件が満たされた時にメール等で通知を受け取ることができます。",
      },
      areaSample: '〇〇工場/支店/自宅etc.',
      address: '住所',
      centerAddress: '選択中エリア',
      selectArea: 'エリアを面で選択',
      numOfConditions: '条件数',
      pointOrArea: '地点/エリア',
      asPoint: '地点',
      asArea: 'エリア',
      variable: '変数',
      floodDepth: '浸水深',
      waterLevel: '河川水位',
      addressSample: '〇〇市〇〇町',
      searchToMove:"検索して地図を移動",
      longitude: '経度',
      latitude: '緯度',
      inputManually: '緯度経度を手動入力',
      goNext: '次へ（アラート条件登録）',
      tooltip: {
        areaName:
          'お客様が地点を記録する際のラベルに相当するものです。実際の地点名と一致している必要はありません。',
        areaOrPoint: "アラート登録の際に地点として登録されたか一定の範囲（エリア）として登録されたかを表示します.",
        addressInput: "住所の入力はおおまかで結構です。入力された住所に合わせて右の地図が移動しますのでアラートに設定したい地点を地図上で選択することもできます。",
        clickOnMap:"右の地図上で登録したい場所をクリックすることで設定が可能です。",
        shareWithClientTooltip: "このアラートを組織内で共有するかの設定です。ここがONになっている場合、このアラートは組織内の他のユーザーにも表示されます。",
      },
      areaNameSample: '〇〇工場 ',
      invalidLatLon: '有効な緯度経度を入力してください.',
    },
    alertList: {
      registered: '登録一覧',
      conditionList: 'アラート条件一覧',
      selectAlert: 'アラートを選択',
      conditionUnregistered: 'アラートの条件が登録されていません。',
      condition: '条件',
      conditionSetter: {
        variable: '変数',
        floodForecast: '浸水予測',
        precipitation: '降水量',
        waterLevel: '河川水位',
        timerange: '時刻',
        threshold: '閾値',
        notificationMethod: '通知方法',
        mail: 'メール',
        slack: 'Slack',
        in: '(',
        hours: '時間後以内）が',
        cm: 'cmを超えたら',
        updateComplete:"アラート条件を更新しました",
        updateFailed:"アラート条件の更新に失敗しました",
        validationMsg:{
        timeRange: 'には36以下の値を入力してください.',
        floodForecast: 'には{{thresh}} 以上の値を入力してください.',
        precipitation: 'には{{thresh}} 以上の値を入力してください.',
        waterLevel: 'には{{thresh}} 以上の値を入力してください.',
      },
      },
      tooltip: {
        notification:
          'メール: 本システムに登録のメールアドレスに通知が行きます. \nSlack: 登録のSlackに通知が行きます.',
      },
      addCondition: '条件を追加',
      save: 'この内容で保存',
    },
  },
};
